// vendor.js is prebuilt using the DLL plugin
// Therefore this file is not HMR enabled.
// It must be spesifically compiled on each change. webpack --config webpack.config.vendor.js 
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import PortalVue from 'portal-vue'

// import '@babel/polyfill'

// Register components. Should be in vendor
import './components/register'
// Register filters
import './js/filters'
import './js/setup'

Vue.use(PortalVue)
Vue.use(Vuelidate)
Vue.config.devtools = true
